import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { matchRoutes } from 'react-router-config';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';

import store from '../../state';
import Preloader from '../preloader';

class PendingNavDataLoader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      previousLocation: null,
      transitioning: false,
    };

    this.mounted = true;
  }

  componentWillReceiveProps(nextProps) {
    const navigated = nextProps.location.pathname !== this.props.location.pathname;
    const { routes } = this.props;

    if (navigated) {
      // save the location so we can render the old screen
      this.setState({
        previousLocation: this.props.location,
      });

      const branches = matchRoutes(routes, nextProps.location.pathname);
      const promises = branches.map((branch) => {
        const { fetchData } = branch.route.component;
        return fetchData instanceof Function ?
          fetchData(store.dispatch, branch) : Promise.resolve(null);
      });

      // load data while the old screen remains
      Promise.all(promises).then(() => {
        this.setState({
          transitioning: true,
        }, () => {
          setTimeout(() => {
            if (!this.mounted) return;
            if (window) window.scrollTo(0, 0);
            this.setState({
              transitioning: false,
              previousLocation: null,
            });
          }, 500);
        });
      });
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  render() {
    const { children, location, showMenu } = this.props;
    const { previousLocation, transitioning } = this.state;
    // let preloader = previousLocation ? <Preloader/> : null;

    let className = 'app';

    let pathSlug = location.pathname.toLowerCase().replace(/\//g, '_').replace(/[^a-z0-9\-_]/g, '-');
    pathSlug = pathSlug.replace(/^[_-]+/, '').replace(/[_-]+$/, '');
    if (!pathSlug) pathSlug = 'home';

    className += ` path-${pathSlug}`;
    if (previousLocation) className += ' hydrating';
    if (showMenu) className += ' menu-visible';
    if (transitioning) className += ' transitioning';

    return (
      <div className={className}>
        <Route
          location={previousLocation || location}
          render={() => children}
        />
        <Preloader />
      </div>
    );
  }
}

PendingNavDataLoader.propTypes = {
  location: PropTypes.object.isRequired,
  routes: PropTypes.array.isRequired,
  children: PropTypes.any.isRequired,
  showMenu: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  showMenu: state.get('showMenu'),
});

export default connect(mapStateToProps)(PendingNavDataLoader);



// WEBPACK FOOTER //
// ./src/components/app/nav-loader.jsx